import Validation from "@/classes/global/Validation";
import ValidationBase from "@/classes/global/ValidationBase";

export default class CourierBookingValidation extends ValidationBase{

    constructor() {
        super();

        this.customerRef = new Validation();
        this.customerRefTwo = new Validation();
        this.collectByDate = new Validation();
        this.collectByTime = new Validation();
        this.description = new Validation();
        this.comments = new Validation();
        this.deliveryDate = new Validation();
        this.deliveryTime = new Validation();
        this.currency = new Validation();
        this.value = new Validation();
        this.service = new Validation();
        this.termsOfShipment = new Validation();
        this.totalPieces = new Validation();
        this.totalWeight = new Validation();
        this.customsStatus = new Validation();
        this.customsComments = new Validation();

    }





}
